import { createContext, type ReactNode, use, useCallback } from 'react';

const StepScopeContext = createContext<string | undefined>(undefined);

type StepScopeProviderProps = {
  prefix: string;
  children: ReactNode;
};

export const StepScopeProvider = ({ prefix, children }: StepScopeProviderProps) => (
  <StepScopeContext.Provider value={prefix}>{children}</StepScopeContext.Provider>
);

export const useStepScope = () => {
  const prefix = use(StepScopeContext);

  return useCallback((id: string): string => (prefix ? `${prefix}-${id}` : id), [prefix]);
};
